import React, { useState, useRef, useCallback, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Close from '@mui/icons-material/Close';
import Button from 'react-bootstrap/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Editor } from '@tinymce/tinymce-react';
import { ToastContainer, toast } from 'react-toastify';
import { createFile, sendSingleEmail, askGPT } from '../../../common/api';
import { storeMedia, createId, extractImages, getMimeTypeFromExtension, render, generateRenderParams } from '../../../common/utils';

import { IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import ChipInput from 'material-ui-chip-input';
import LeoSuggestionBar from '../../Leo/Suggestion';
import ScheduleButton from '../../Modals/ScheduleButton';
import InsertTemplate from '../../Modals/InsertTemplate';
import Modal from '@mui/material/Modal';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import RecipientPicker from '../RecipientPicker';


const EmailInput = ( { label, emails, setEmails, contacts } ) => {
    const [ value, setValue ] = useState( [] );
    
    return (
            <Row className='align-items-center'>
                <Col xs='auto'>
                    {label}
                </Col>
                <Col className='tf-email-chip me-1 d-flex align-items-center'>
                    <RecipientPicker channel='email' value={emails} onChange={setEmails} contacts={contacts} />
                </Col>
            </Row>
    );
};

const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    zIndex: 10,
    pointerEvents: 'none',
};

const EmailSingle2 = React.forwardRef( ( { open, onClose, onMinimize, uid, user, contacts, contactEmails, opps, loans, templates, globalStatus, loanStatus, obj, objType, tmpl, tmplContent, sub, attachment }, ref ) => {
    const [ minimized, setMinimized ] = useState( false );
    const [ showCc, setShowCc ] = useState( false );
    const [ showBcc, setShowBcc ] = useState( false );
    const [ from, setFrom ] = useState( '' );
    const [ signature, setSignature ] = useState( '' );
    const [ senderList, setSenderList ] = useState( [] );
    const [ sendersLoaded, setSendersLoaded ] = useState( false );
    const [ to, setTo ] = useState( [] );
    const [ cc, setCc ] = useState( [] );
    const [ bcc, setBcc ] = useState( [] );
    const [ recipSuggestions, setRecipSuggestions ] = useState( [ { name: 'BTS', email: 'support@thirdfloor.ai' } ] );
    const [ subject, setSubject ] = useState( '' );
    const [ body, setBody ] = useState( '' );
    const [ attachments, setAttachments ] = useState( [] );
    const [ showVideo, setShowVideo ] = useState( false );
    const [ showChatGPT, setShowChatGPT ] = useState( false );
    const [ showTemplates, setShowTemplates ] = useState( false );
    const [ modal, setModal ] = useState( '' );
    const [ prompt, setPrompt ] = useState( '' );
    const [ waiting, setWaiting ] = useState( false );
    const [ displayText, setDisplayText ] = useState( '' );
    const [ chatResp, setChatResp ] = useState( '' );
    const [ replace, setReplace ] = useState( false );
    const [ promptType, setPromptType ] = useState( 'freeform' );
    const [ allTmpls, setAllTmpls ] = useState( {} );
    const [ tmplUsed, setTmplUsed ] = useState( '' );
    const [ aiEnabled, setAiEnabled ] = useState( false );
    const [ isDragActive, setIsDragActive ] = useState( false );
    const [ sending, setSending ] = useState( false );
    const [ includeTask, setIncludeTask ] = useState( false );
    const [ taskType, setTaskType ] = useState( 'To-Do' );
    const [ taskDay, setTaskDay ] = useState( '' );
    const [ loading, setLoading ] = useState( true );
    const [ loadedTmpl, setLoadedTmpl ] = useState( false );
    const [ selectedTmpl, setSelectedTmpl ] = useState( '' );
    const [ editorHeight, setEditorHeight ] = useState( 428 );

    const panelRef = useRef( null );
    const metaRef = useRef( null );
    const attachmentsRef = useRef( null );
    const actionsRef = useRef( null );
    const leoRef = useRef( null );
    const editorRef = useRef( null );
    const tmplRef = useRef( null );
    tmplRef.current = allTmpls;
    const setTmplRef = useRef( null );
    setTmplRef.current = setSelectedTmpl;
    const senderRef = useRef( null );
    senderRef.current = senderList;
    const bbObjRef = useRef( null );
    const objRef = useRef( null );
    objRef.current = obj;
    const objTypeRef = useRef( null );
    objTypeRef.current = objType;
    const uidRef = useRef( null );
    uidRef.current = uid;
    const fileInputRef = useRef( null );
    
    const formatRecip = useCallback( ( email ) => {
        const cid = contactEmails[email];
        let recip = { email: email };
    
        if ( cid ) {
            const c = contacts[cid];
            recip['cid'] = cid;
    
            if ( c.email && c.email.length && c.email.toLowerCase() === email ) {
                recip['name'] = c.firstname + ' ' + c.lastname;
            }
        }
    
        return recip;
    }, [ contacts, contactEmails ] );

    const sendEmail = async ( d, t, tz ) => {
        setSending( true );
    
        const e = editorRef.current.getContent();
        const body = await extractImages( user.aid, user.email, e );
        // const styledBody = e.replace( /<p>/g, '<p class="tf" style="font-size: 12pt; font-family: Calibri, sans-serif;">' );
        
        const formattedTo = to.map( t => {
            return formatRecip( t.toLowerCase() );
        } );
        const formattedCc = cc.map( t => {
            return formatRecip( t.toLowerCase() );
        } );
        const formattedBcc = bcc.map( t => {
            return formatRecip( t.toLowerCase() );
        } );
        const f = senderList.find( f => f.email === from );
        const formattedFrom = { email: f.email, name: f.name };
    
        let msg = {
            subject: subject,
            to: formattedTo,
            from: formattedFrom,
            cc: formattedCc,
            bcc: formattedBcc,
            body: body, // e,
            tmpl: tmplUsed,
            attachments: attachments,
            date: d,
            time: t,
            tz: tz,
            channel: 'email'
        };
    
        if ( objType === 'loan' ) {
            msg['lid'] = obj.lid;
            const c = obj.borrowers?.find( f => f.label === 'Primary' );
            if ( c ) {
                msg['contactId'] = c.cid;
            }
        } else if ( objType === 'contact' ) {
            msg['contactId'] = obj.cid;
        }
    
        console.log( 'msg: ', msg );
            
        const sent = await sendSingleEmail( obj.aid, user.email, msg );
        // if ( sent.length ) {
            setSending( false );
            toast.success( `The Email has been Sent`, { theme: 'dark' } );
            onClose();
        // }
        // console.log( sent );
    };

    const switchSender = ( fromEmail ) => {
        const s = senderList.find( f => f.email === fromEmail );
        if ( s ) {
            setFrom( s.email );
            setSignature( s.signature );
        }
    };

    const handleDragEnter = (event) => {
        event.preventDefault();
        setIsDragActive( true );
    };
      
    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragActive( true );
    };
      
    const handleDragLeave = (event) => {
        event.preventDefault();
        setIsDragActive( false );
    };

    const handleFileChange = async ( event ) => {
        const selectedFiles = Array.from( event.target.files );
        const uploadedFiles = await Promise.all( selectedFiles.map( file => storeFile( file ) ) );
        event.target.value = null;
    };
    
    const storeFile = async ( f ) => {
        const reader = new FileReader();
            
        reader.onabort = () => {
            toast.success( `The upload process on ${f.path} has been aborted`, { theme: 'dark' } );
        }
        reader.onerror = () => {
            toast.success( `There's been an error while uploading ${f.path}`, { theme: 'dark' } );
        }
        reader.onload = async () => {
            const b = new Blob( [ reader.result ] );
            const ext = f.name.split( '.' ).pop();
            let n = createId( 'file' );
            if ( ext ) {
                n += '.' + ext;
            }
                    
            const name = await storeMedia( objRef.current.aid, uid, n, b, getMimeTypeFromExtension( ext ) );
                    
            let cid;
            let lid;

            if ( objTypeRef.current === 'contact' ) {
                cid = objRef.current.cid;
            } else if ( objTypeRef.current === 'loan' ) {
                lid = objRef.current.lid;
                const c = objRef.current.borrowers?.find( f => f.label === 'Primary' );
                if ( c ) {
                    cid = c.cid;
                }
            }

            let file = {
                mediaUrl: name,
                name: f.name
            }
            if ( cid ) {
                file['cid'] = cid;
            }
            if ( lid ) {
                file['lid'] = lid;
            }

            await createFile( objRef.current.aid, uidRef.current, file );

            setAttachments( prev => [
                ...prev,
                { name: file.name, fid: file.mediaUrl }
            ] );
            console.log( 'uploaded: ', name );
        }
        reader.readAsArrayBuffer( f );
    };

    const handleDrop = async ( event, editor ) => {
        event.preventDefault();
        setIsDragActive( false );

        const files = Array.from( event.dataTransfer.files );
        for ( const f of files ) {
            if ( f.type.startsWith( 'image/' ) ) {
                editor.insertContent( `<img src="${URL.createObjectURL( f )}" />` );
            } else {
                await storeFile( f );
            }
        }
    };

    const removeAttachment = ( file ) => {
        setAttachments( prev => {
            const list = prev.filter( f => f.name !== file );
            return [ ...list ];
        } );
    }

    const prepAskAI = async ( prompt, ptype ) => {
        setPromptType( ptype );
        setPrompt( prompt );
        setShowChatGPT( true );
        setReplace( true );
    };

    const loadTemplates = ( editor ) => {
        let list = [];
        
        if ( Object.keys( tmplRef.current ).length ) {
            Object.keys( tmplRef.current ).sort().forEach( name => {
                const t = tmplRef.current[name];
                if ( !t.objects || t.objects.includes( objType ) ) {
                    const content = render( t.body );
                    let fresh = false;
                    let sig = '';

                    list.push( {
                        type: 'menuitem',
                        text: t.name,
                        onAction: () => {
                            if ( t.to ) {
                                const rTo = render( t.to );
                                const addrs = rTo.split( ',' );
                                setTo( addrs.filter( f => f.length > 4 ) );
                            }
                            if ( t.cc ) {
                                const rCc = render( t.cc );
                                const addrs = rCc.split( ',' );
                                setCc( addrs.filter( f => f.length > 4 ) );
                                setShowCc( true );
                            }
                            if ( t.bcc ) {
                                const rBcc = render( t.bcc );
                                const addrs = rBcc.split( ',' );
                                setBcc( addrs.filter( f => f.length > 4 ) );
                                setShowBcc( true );
                            }
                            if ( t.from ) {
                                const s = senderRef.current.find( f => f.email === t.from );
                                if ( s ) {
                                    setFrom( t.from );
                                    if ( s.signature && s.signature.length ) {
                                        sig = render( s.signature );
                                    } else if ( user.signature && user.signature.length ) {
                                        sig = render( user.signature );
                                    }
                                    fresh = true;
                                }
                            }
                            if ( t.subject ) {
                                setSubject( render( t.subject ) );
                                // setSubject( t.subject );
                            }
                            if ( t.attachments ) {
                                setAttachments( t.attachments );
                            }

                            if ( fresh ) {
                                editor.setContent( content + '<br /><br />' + sig );
                            } else {
                                editor.insertContent( content );
                            }
                            
                            setTmplUsed( t.tid );
                        }
                    } );
                }
            } );
        }
        if ( user.signature && user.signature.length ) {
            list.push( {
                type: 'menuitem',
                text: 'Signature',
                onAction: () => editor.insertContent( user.signature )
            } );
        }
        
        return ( list );
    }

    const loadPromptContextSubMenu = ( editor ) => {
        return [
            {
                type: 'item',
                text: 'Summarize',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'summarize' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: "item",
                text: 'Explain',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'explain' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Improve Writing',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'improve-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Simplify Writing',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'simplify-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Overcome Objection',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'objection-handler' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Check Guideline Accuracy',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'guideline-accuracy' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        // buttonApi.setEnabled( selectedText );
                    };
                    buttonApi.setEnabled( false );
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            }
        ]
    }

    const loadPromptContextMenu = ( editor ) => {
        return [
            {
                type: 'submenu',
                text: 'MortgageGPT',
                icon: 'ai',
                getSubmenuItems: () => {
                    const selectedText = editor.selection.getContent( { format: 'text' } );
                    return selectedText ? loadPromptContextSubMenu( editor ) : ''; // Show submenu items if text is selected
                },
            }
        ]
    }

    const loadPromptMenu = ( editor ) => {
        return [ 
            {
                type: 'menuitem',
                text: 'Overcome Objections',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'objection-handler' );
                }
            }, 
            {
                type: 'menuitem',
                text: 'Check Guideline Accuracy',
                enabled: false,
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'guideline-accuracy' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Suggest a Subject Line',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'subject-line-reco' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Summarize',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'summarize' );
                }
            },
            {
                type: 'menuitem',
                text: 'Explain',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'explain' );
                }
            },
            {
                type: 'menuitem',
                text: 'Improve Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'improve-writing' );
                }
            },
            {
                type: 'menuitem',
                text: 'Simplify Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'simplify-writing' );
                }
            }
        ]
    }

    const resizeEditor = () => {
        if ( editorRef?.current && panelRef?.current && metaRef?.current && actionsRef?.current ) {
            let h = panelRef.current.offsetHeight - 35 - metaRef.current.offsetHeight - actionsRef.current.offsetHeight;

            const container = editorRef.current.getContainer();
            // Update the container's height
            container.style.height = `${h}px`;
            
            // Optionally, update the height of the inner iframe (editable area)
            // Note: Adjust the subtraction (e.g., toolbar height) as needed.
            const iframe = container.querySelector( 'iframe' );
            if ( iframe ) {
                // Assuming ~50px is taken up by toolbars or padding—adjust if necessary
                iframe.style.height = `${h - 50}px`;
            }
            
            // Fire a resize event so TinyMCE can adjust internal elements if needed
            editorRef.current.fire( 'resize' );
        }
    };

    useEffect( () => {
        if ( user?.stack?.ai?.copilot?.active ) {
            setAiEnabled( true );
        } else {
            setAiEnabled( false );
        }
    }, [ user ] );

    useEffect( () => {
        if ( !minimized && metaRef.current && actionsRef.current ) {
            resizeEditor();
        }
    }, [ attachments, aiEnabled, showCc, showBcc, minimized, recipSuggestions ] );

    useEffect( () => {
        setRecipSuggestions( prev => {
            return prev.filter( f => {
                return to.concat( cc ).concat( bcc ).find( e => e === f.email ) ? false : true;
            } );
        } );
    }, [ to, cc, bcc ] );

    useEffect( () => {
        if ( loading ) {
            const list = [];
            switch ( objType ) {
                case 'contact':
                    // handle primary contact
                    if ( obj.email && obj.email.length && !obj.optoutEmail ) {
                        setTo( [ obj.email.toLowerCase() ] );
                        // list.push( { name: obj.name, email: obj.email.toLowerCase() } );
                    }
                    // handle opp partners
                    if ( obj.priRole === 'borrower' ) {
                        Object.keys( opps ).forEach( loid => {
                            const lo = opps[loid];
                            if ( lo.relationships && lo.relationships.find( f => f.cid === obj.cid ) ) {
                                const cobos = lo.relationships.filter( f => f.cid !== obj.cid );
                                cobos.forEach( f => {
                                    const c = contacts[f.cid];
                                    if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                                        list.push( { name: c.name, email: c.email.toLowerCase() } );
                                    }
                                } );
                            }
                        } );
                    }
                    // handle contact partners
                    if ( obj.emailPartner1 && obj.emailPartner1.length && !list.find( e => e.email === obj.emailPartner1.toLowerCase() ) ) {
                        list.push( { name: `${obj.firstnamePartner1} ${obj.lastnamePartner1}`, email: obj.emailPartner1.toLowerCase() } );
                    }
                    if ( obj.emailPartner2 && obj.emailPartner2.length && !list.find( e => e.email === obj.emailPartner2.toLowerCase() ) ) {
                        list.push( { name: `${obj.firstnamePartner2} ${obj.lastnamePartner2}`, email: obj.emailPartner2.toLowerCase() } );
                    }
                    // handle referral source
                    if ( obj.referredById ) {
                        const c = contacts[obj.referredById];
                        if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                            list.push( { name: c.name, email: c.email.toLowerCase() } );
                        }
                    }
                    break;

                case 'loan':
                    // handle borrowers
                    if ( obj.borrowers && obj.borrowers.length ) {
                        const pri = obj.borrowers.find( f => f.label === 'Primary' );
                        if ( pri ) {
                            const c = contacts[pri.cid];
                            if ( c && c.email && c.email.length && !c.optoutEmail ) {
                                list.push( { name: c.name, email: c.email.toLowerCase() } );
                            }
                        }
                        const cobos = obj.borrowers.filter( f => f.label !== 'Primary' );
                        cobos.forEach( f => {
                            const c = contacts[f.cid];
                            if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                                list.push( { name: c.name, email: c.email.toLowerCase() } );
                            }
                        } );
                    }
                    // handle agents
                    if ( obj.baId ) {
                        const c = contacts[obj.baId];
                        if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                            list.push( { name: c.name, email: c.email.toLowerCase() } );
                        }
                    }
                    if ( obj.laId ) {
                        const c = contacts[obj.laId];
                        if ( c && c.email && c.email.length && !c.optoutEmail && !list.find( e => e.email === c.email.toLowerCase() ) ) {
                            list.push( { name: c.name, email: c.email.toLowerCase() } );
                        }
                    }
                    break;

                default:
            }
            setRecipSuggestions( list );
            setLoading( false );
        }
    }, [ objType, obj, loading, contacts, loans, opps ] );

    useEffect( () => {
        if ( user && !sendersLoaded ) {
            setFrom( user.email );
            setSignature( user.signature );
    
            let list = [ {
                email: user.email,
                name: user.name,
                signature: user.signature
            } ];
    
            if ( user.additionalEmailSenders && user.additionalEmailSenders.length ) {
                user.additionalEmailSenders.forEach( s => {
                    if ( !s.signature ) {
                        const tm = user?.lists?.team?.find( f => f.email === s.email );
                        if ( tm && tm.signature ) {
                            s.signature = tm.signature;
                        }
                    }
                    list.push( s );
                } );
            }
            
            setSenderList( list );
            setSendersLoaded( true );
        }
    }, [ user, sendersLoaded ] );

    useEffect( () => {
        const params = generateRenderParams( { obj, objType, contacts, loans, opps, user } );
        const accts = user?.lists?.accounts;
	    const team = user?.lists?.team;
	
        if ( tmplContent && tmplContent.length ) {
            setBody( render( tmplContent, params, contacts ) );
        } else if ( tmpl || selectedTmpl?.length ) {
            console.log( 'tmpl', tmpl );
            const tid = tmpl;
            let t;
            let sig = signature;
    
            if ( ( loadedTmpl || !sendersLoaded ) && !selectedTmpl ) {
                console.log( 'gotta wait...', loadedTmpl, sendersLoaded, selectedTmpl );
                return;
            }
                
            if ( user.templates && user.templates.length ) {
                t = user.templates.find( f => f.tid === tid );
            }
    
            if ( !t ) {
                const a = accts?.find( f => f.id === obj.aid );
                if ( a && a.crm && a.crm.meta.templates && a.crm.meta.templates.length ) {
                    t = a.crm.meta.templates.find( f => f.tid === tid );
                }
            }

            if ( !t ) {
                Object.keys( templates ).forEach( tid => {
                    if ( tid === selectedTmpl ) {
                        t = templates[tid];
                    }
                } );
            }
                
            if ( t ) {
                console.log( 'rendering:', t );
                if ( t.to ) {
                    const rTo = render( t.to, params, contacts );
                    const addrs = rTo.split( ',' );
                    setTo( addrs.filter( f => f.length > 4 ).map( m => {
                        return {
                            key: `auto:${m}`.toLowerCase(),
                            label: m,              // primary line
                            sublabel: m,           // secondary line (email or phone)
                            address: m,                     // normalized email or E.164 phone
                            channel: 'email',                     // 'email' | 'sms'
                            firstname: '',
                            lastname: '',
                            name: '',
                            preferredName: '',
                            id: `auto:${m}`
                        };
                    }) );
                }
                if ( t.cc ) {
                    const rCc = render( t.cc, params, contacts );
                    const addrs = rCc.split( ',' );
                    const cc = addrs.filter( f => f.length > 4 ).map( m => {
                        return {
                            key: `auto:${m}`.toLowerCase(),
                            label: m,              // primary line
                            sublabel: m,           // secondary line (email or phone)
                            address: m,                     // normalized email or E.164 phone
                            channel: 'email',                     // 'email' | 'sms'
                            firstname: '',
                            lastname: '',
                            name: '',
                            preferredName: '',
                            id: `auto:${m}`
                        };
                    } );
                    setCc( cc );
                    setShowCc( cc.length > 0 );
                }
                if ( t.bcc ) {
                    const rBcc = render( t.bcc, params, contacts );
                    const addrs = rBcc.split( ',' );
                    const bcc = addrs.filter( f => f.length > 4 ).map( m => {
                        return {
                            key: `auto:${m}`.toLowerCase(),
                            label: m,              // primary line
                            sublabel: m,           // secondary line (email or phone)
                            address: m,                     // normalized email or E.164 phone
                            channel: 'email',                     // 'email' | 'sms'
                            firstname: '',
                            lastname: '',
                            name: '',
                            preferredName: '',
                            id: `auto:${m}`
                        };
                    } );
                    setBcc( bcc );
                    setShowBcc( bcc.length > 0 );
                }
                if ( t.from ) {
                    const s = senderList.find( f => f.email === t.from );
                    const tm = team.find( f => f.email === t.from );

                    if ( s ) {
                        setFrom( render( t.from, params, contacts ) );
                        if ( s.signature && s.signature.length ) {
                            sig = s.signature;
                        } else if ( tm && tm.signature && tm.signature.length ) {
                            sig = tm.signature;
                        } else if ( user.signature && user.signature.length ) {
                            sig = user.signature;
                        }
                    }
                }
                if ( t.attachments ) {
                    setAttachments( t.attachments );
                }
                    
                setSubject( render( t.subject, params, contacts ) );
    
                if ( t.removeSig === true ) {
                    setBody( render( t.body, params, contacts ) );
                } else {
                    setBody( render( t.body, params, contacts ) + render( sig, params, contacts ) );
                }
    
                setSignature( sig );
                
                setTmplUsed( t.tid );
            }
    
            setLoadedTmpl( true );
        } else if ( signature && signature.length ) {
            setBody( '<br /><br />' + render( signature, params, contacts ) );
        }
    
        if ( attachment ) {
            setAttachments( prev => {
                const list = prev.filter( f => f.name !== attachment.name );
                return [ ...list, { ...attachment } ];
            } );
        }
    }, [ templates, tmplContent, tmpl, signature, senderList, selectedTmpl, attachment, user.signature, user.templates, user, obj.aid, obj, objType, contacts, loans, opps, loadedTmpl, sendersLoaded ] );
    
    useEffect( () => {
        console.log( 'selectedTmpl: ', selectedTmpl );
        console.log( '~tmpl:', tmpl );
    }, [ selectedTmpl, tmpl ])

    return (
        <Container ref={ref} className='email-window-container w-100'>
            <Row ref={panelRef} className='h-100 p-0 m-0'>
                <Col className='p-0 m-0'>
                    <Row className='email-window-header p-0 align-items-center'>
                        <Col className='pe-0'>
                            <Row className='align-items-center w-100'>
                                <Col className='email-header-subject ps-3 pt-1'>
                                    {
                                        !subject.length ? (
                                            <span>Draft Email</span>
                                        ) : (
                                            <span>{subject}</span>
                                        )
                                    }
                                </Col>
                                <Col xs='auto' className='text-end px-0'>
                                    <IconButton onClick={ () => { setMinimized( !minimized ); onMinimize(); } }>
                                        {
                                            minimized ? (
                                                <KeyboardArrowUpIcon fontSize='small' style={ { color: '#FFF' } } />
                                            ) : (
                                                <KeyboardArrowDownIcon fontSize='small' style={ { color: '#FFF' } } />
                                            )
                                        }
                                    </IconButton>
                                    <IconButton onClick={onClose}>
                                        <Close fontSize='small' style={ { color: '#FFF' } } />
                                    </IconButton>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row ref={metaRef} className='email-window-meta flex-grow-0 overflow-hidden'>
                        <Col>
                            <Row>
                                <Col>
                                    <Row className='py-2'>
                                        <Col xs='auto'>From</Col>
                                        {
                                            ( senderList.length === 1 ) ? (
                                                <Col className='tf-email-header-value'>{user.email}</Col>
                                            ) : (
                                                <Col xs='auto' className='tf-email-header-value tf-form-select-field me-1'>
                                                    <Form.Select size='sm' className='tf-modal-select-input' value={from} onChange={ ( e ) => switchSender( e.target.value ) }>
                                                        {
                                                            senderList.map( ( s, idx ) => <option key={idx} value={s.email}>{s.email}</option> )
                                                        }
                                                    </Form.Select>
                                                </Col>
                                            )
                                        }
                                        <Col className='text-end'>
                                            <Button variant='link' className='tf-email-button-link pe-2' size='sm' onClick={() => setShowCc( !showCc )}>Cc</Button>
                                            <Button variant='link' className='tf-email-button-link ps-2' size='sm' onClick={() => setShowBcc( !showBcc )}>Bcc</Button>
                                        </Col>
                                    </Row>
                                    <Row className='py-2'>
                                        <Col>
                                            <EmailInput label="To" emails={to} setEmails={setTo} contacts={contacts} />
                                        </Col>
                                    </Row>
                                    {
                                        showCc ? (
                                            <Row className='py-2'>
                                                <Col>
                                                    <EmailInput label="Cc" emails={cc} setEmails={setCc} contacts={contacts} />
                                                </Col>
                                            </Row>
                                        ) : (
                                            null
                                        )
                                    }
                                    {
                                        showBcc ? (
                                            <Row className='py-2'>
                                                <Col>
                                                    <EmailInput label="Bcc" emails={bcc} setEmails={setBcc} contacts={contacts} />
                                                </Col>
                                            </Row>
                                        ) : (
                                            null
                                        )
                                    }
                                    {
                                        recipSuggestions.length ? (
                                            // <Row className='tf-email-recip-suggestion-bar py-2'>
                                            //     <Col>
                                            //         <span className='tf-email-recip-suggestion-label fw-semibold pe-2'>Suggested Recipients:</span>
                                            //         {
                                            //             recipSuggestions.map( ( r, i ) => {
                                            //                 return (
                                            //                     <Button key={i} variant='link' className='tf-email-button-link pe-2' size='sm' onClick={ () => setTo( [ ...to, r.email ] ) }>{r.name}</Button>
                                            //                 )
                                            //             } )
                                            //         }
                                            //     </Col>
                                            // </Row>
                                            null
                                        ) : (
                                            null
                                        )
                                    }
                                    <Row className='tf-email-shadow-bottom pb-2' />
                                    <Row className='tf-email-shadow-bottom py-2'>
                                        <Col className='tf-email-text-input ps-0'>
                                            <Form.Control type='text' value={subject} onChange={ ( e ) => setSubject( e.target.value ) } placeholder='Subject' />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {
                                aiEnabled ? (
                                    null // <LeoSuggestionBar innerRef={leoRef} />
                                ) : (
                                    null
                                )
                            }
                        </Col>
                    </Row>
                    <Row className="email-window-editor" style={{ flex: '1 1 auto', overflowY: 'auto' }}>
                        <Col className='p-0' style={ { position: 'relative' } }>
                            { isDragActive && <div style={overlayStyle}>Drop Files Here...</div> }
                            <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} multiple />
                            <Editor
                                tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                init={ { 
                                    height: editorHeight,
                                    menubar: false, 
                                    statusbar: false,
                                    toolbar_mode: 'floating',
                                    toolbar_location: 'bottom',
                                    toolbar: 'bold italic underline formatting | link image tfattachment insertTemplate emoticons | code',
                                    toolbar_groups: {
                                        formatting: {
                                            icon: 'image-options',
                                            tooltip: 'Formatting',
                                            items: 'fontfamily fontsize | forecolor backcolor | align bullist numlist'
                                        }
                                    },
                                    visual: false,
                                    content_style: 'body { font-family:Arial; font-size:12pt; }',
                                    setup: ( editor ) => {
                                        editor.on( 'dragstart', handleDragEnter );
                                        editor.on( 'dragover', handleDragOver );
                                        editor.on( 'dragend', handleDragLeave );
                                        editor.on( 'dragleave', handleDragLeave );
                                        editor.on( 'drop', ( event ) => handleDrop( event, editor ) );
                                        editor.on( 'mouseleave', handleDragLeave );

                                        editor.ui.registry.addButton( 'tfvideo', {
                                            icon: 'embed',
                                            tooltip: 'Insert Video',
                                            enabled: true,
                                            onAction: (_) => {
                                                setShowVideo( true );
                                            },
                                        } );
                                        // editor.ui.registry.addMenuButton( 'tftmpl', {
                                        //     text: 'Templates',
                                        //     fetch: ( cb ) => {
                                        //         const items = loadTemplates( editor );
                                        //         cb( items );
                                        //     }
                                        // } );
                                        editor.ui.registry.addMenuButton( 'tfaiprompts', {
                                            icon: 'ai-prompt',
                                            fetch: ( cb ) => {
                                                const items = loadPromptMenu();
                                                cb( items );
                                            }
                                            } );
                                        editor.ui.registry.addButton( 'tfchatgpt', {
                                            icon: 'ai',
                                            tooltip: 'Ask MortgageGPT',
                                            onAction: () => {
                                                setShowChatGPT( true );
                                            }
                                        } );
                                        // Add custom paperclip icon
                                        editor.ui.registry.addIcon( 'tfpaperclip', `
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000"  height="24" width="24" viewBox="0 0 36 36">
                                            <path d="M22.562,12.491c0,0,1.227-0.933,0.293-1.866c-0.934-0.933-1.842,0.271-1.842,0.271l-9.389,9.391
                                            c0,0-2.199,2.838-3.871,1.122c-1.67-1.718,1.121-3.872,1.121-3.872l12.311-12.31c0,0,2.873-3.165,5.574-0.466
                                            c2.697,2.7-0.477,5.579-0.477,5.579L12.449,24.173c0,0-4.426,5.113-8.523,1.015s1.066-8.474,1.066-8.474L15.494,6.209
                                            c0,0,1.176-0.982,0.295-1.866c-0.885-0.883-1.865,0.295-1.865,0.295L1.873,16.689c0,0-4.549,4.989,0.531,10.068
                                            c5.08,5.082,10.072,0.533,10.072,0.533l16.563-16.565c0,0,3.314-3.655-0.637-7.608s-7.607-0.639-7.607-0.639L6.543,16.728
                                            c0,0-3.65,2.969-0.338,6.279c3.312,3.314,6.227-0.39,6.227-0.39L22.562,12.491z"/>
                                            </svg>
                                        ` );
                                        // Add button using the custom paperclip icon
                                        editor.ui.registry.addButton( 'tfattachment', {
                                            icon: 'tfpaperclip',
                                            tooltip: 'Attach File',
                                            onAction: () => {
                                                fileInputRef.current.click();
                                            }
                                        } );
                                                            
                                        editor.ui.registry.addContextMenu( 'aiContextMenu', {
                                            update: ( element ) => {
                                                const selectedText = editor.selection.getContent( { format: 'text' } );
                                                return selectedText ? loadPromptContextMenu( editor ) : ''; // Show the custom item if text is selected
                                            },
                                        } );

                                        editor.ui.registry.addButton( 'insertTemplate', {
                                            text: 'Insert Template',
                                            onAction: () => {
                                                setModal( <InsertTemplate obj={objRef?.current} objType={objTypeRef?.current} setSelectedTmpl={setTmplRef?.current} editor={editor} shouldRender={true} close={ () => setShowTemplates( false ) } /> );
                                                setShowTemplates( true );
                                            }
                                        });
                                    },
                                    browser_spellcheck: true,
                                    contextmenu: 'aiContextMenu link',
                                    automatic_uploads: false,
                                    license_key: 'gpl'
                                } }
                                onInit={ ( evt, editor ) => {
                                    editorRef.current = editor;
                                    resizeEditor();
                                } }
                                initialValue={body}
                                plugins='emoticons code lists link image'
                            />
                        </Col>
                    </Row>
                    <Row ref={actionsRef} className='p-0 m-0'>
                        <Col className='p-0 m-0'>
                            {
                                attachments.length ? (
                                    <Row ref={attachmentsRef} className='tf-email-attachments py-2 me-0'>
                                        { attachments.map( a => <Col key={a.name} xs='auto' className='pe-0'><span className='tf-email-attachment-file'>{a.name}</span><span className='tf-email-attachment-delete' onClick={ () => removeAttachment( a.name ) }>X</span></Col>) }
                                    </Row>
                                ) : (
                                    null
                                )
                            }
                            <Row className='email-window-controls tf-email-shadow-top align-items-center pt-1 mt-auto'>
                                <Col className='pe-2' xs='auto' style={ { zIndex: '9999' } }>
                                    <ScheduleButton send={sendEmail} disabled={!subject.length || sending} />
                                </Col>
                                {
                                    subject.length ? (
                                        <Col className='pe-2' style={ { zIndex: '9999' } }>
                                            <Form.Group as={Row} className='tf-form-group align-items-center py-1' controlId='follow-up-task'>
                                                <Col className='pe-1' xs='auto'><Form.Check type='checkbox' className='tf-form-checkbox-field' onChange={ () => setIncludeTask( !includeTask ) } /></Col>
                                                <Col xs='auto'>
                                                    <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>
                                                        <Row className='align-items-center'>
                                                            <Col className='p-0' xs='auto'>Create a</Col>
                                                            <Col className='p-0 tf-email-task-select-input' xs='auto'>
                                                                <Form.Select className='ps-1'  value={taskType} onChange={ ( e ) => setTaskType( e.target.value ) }>
                                                                    <option value="To-Do">To-Do</option>
                                                                    <option value="Call">Call</option>
                                                                    <option value="Text Msg">Txt</option>
                                                                    <option value="Email">Email</option>
                                                                </Form.Select>
                                                            </Col>
                                                            <Col className='p-0' xs='auto'>task to follow up</Col>
                                                            <Col className='p-0 tf-email-task-select-input' xs='auto'>
                                                                <Form.Select className='ps-1' value={taskDay} onChange={ ( e ) => setTaskDay( e.target.value ) }>
                                                                    <option value={1}>Tomorrow</option>
                                                                    <option value={2}>This Friday</option>
                                                                    <option value={3}>Next Monday</option>
                                                                    <option value="Custom">Custom</option>
                                                                </Form.Select>
                                                            </Col>
                                                        </Row>
                                                    </Form.Label>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                    ) : (
                                        <Col className='pe-2' style={ { color: 'red', fontSize: '10px' } }>* Subject Required Before Sending</Col>
                                    )
                                }
                                <Col className='ps-2 text-end' xs='auto'><Button variant='outline-dark' onClick={onClose}>Cancel</Button></Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Modal open={showTemplates} onClose={ () => setShowTemplates( false ) }>
                <Fragment>
                    {modal}
                </Fragment>
            </Modal>
            <ToastContainer autoClose={3000} />
        </Container>
    );
} );

const mapProps = ( state ) => ( {
    uid: state.user.email,
    user: state.user,
    contacts: state.contacts.byId,
    contactEmails: state.contacts.byEmail,
    opps: state.leadopps.byId,
    loans: state.loans.byId,
    globalStatus: state.user.meta.global.picklist.status,
    loanStatus: state.user.meta.loan.picklist.status,
    templates: state.templates.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( EmailSingle2 );